import React from "react";
import { Button, TextField, FormLayout, Text } from "@shopify/polaris";
import AuthContainer from "../../AuthContainer";
import BannerCustom from "components/Banners/BannerCustom";
import passwordIMG from "img/icons/entities/password.svg";
import emailIMG from "img/icons/entities/email.svg";
import PageHelmet from "components/PageHelmet";
import useForgotPasswordPage from "../../shared/hooks/useForgotPasswordPage";

export default function ForgotPasswordPage() {
  const {
    t,
    code,
    title,
    description,
    email,
    errorEmail,
    newPassword,
    errorNewPassword,
    newPasswordRepeat,
    errorNewPasswordRepeat,
    serverError,
    setServerError,
    isCodeSent,
    isPasswordChanged,
    isSending,
    isCompleting,
    resendLocked,
    completeErrorMessage,
    completeSuccessMessage,
    serverSuccessMessage,
    setEmail,
    setErrorEmail,
    setNewPassword,
    setErrorNewPassword,
    setNewPasswordRepeat,
    setErrorNewPasswordRepeat,
    doResendCode,
    doForgotStart,
    doForgotComplete,
    validateEmail,
    validatePassword,
    validatePasswordRepeat,
  } = useForgotPasswordPage();

  return (
    <AuthContainer
      title={title}
      description={description}
      content={
        <>
          <PageHelmet title="Forgot password" />
          {serverError ? (
            <BannerCustom
              status="critical"
              message={serverError}
              onDismiss={() => setServerError(false)}
            />
          ) : null}
          {!code && isCodeSent && serverSuccessMessage ? (
            <BannerCustom status="success" message={serverSuccessMessage} />
          ) : null}
          {completeErrorMessage && !isPasswordChanged ? (
            <BannerCustom
              status="critical"
              message={completeErrorMessage}
            />
          ) : null}
          {isPasswordChanged ? (
            <BannerCustom
              status="success"
              message={
                completeSuccessMessage || t("forgotPassword.passChanged")
              }
            />
          ) : null}
          {!code && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (isCodeSent) {
                  doResendCode(e);
                } else {
                  doForgotStart();
                }
              }}
            >
              {(!isCodeSent || !resendLocked) && (
                <TextField
                  name="email"
                  type="email"
                  prefix={
                    <img src={emailIMG} alt="email" style={{ marginTop: 6 }} />
                  }
                  label={
                    <Text color="subdued" variant="bodySm">
                      Enter your email
                    </Text>
                  }
                  placeholder={t("forgotPassword.email")}
                  autoComplete="email"
                  value={email}
                  error={errorEmail}
                  onBlur={() => validateEmail(email)}
                  onChange={(value) => {
                    setEmail(value);
                    setErrorEmail(false);
                    setServerError(false);
                  }}
                />
              )}
              {(!isCodeSent || !resendLocked) && <br />}
              <div>
                {!isCodeSent ? (
                  <Button
                    variant="primary"
                    onClick={doForgotStart}
                    loading={isSending}
                    disabled={isSending}
                  >
                    {t("forgotPassword.recover")}
                  </Button>
                ) : (
                  <Button
                    onClick={doResendCode}
                    variant="primary"
                    loading={isSending}
                    disabled={isSending || resendLocked}
                  >
                    Resend an email
                  </Button>
                )}
                <button style={{ display: "none" }} type="submit">
                  {t("forgotPassword.signIn")}
                </button>
              </div>
            </form>
          )}
          {code && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                doForgotComplete();
              }}
            >
              <FormLayout>
                <TextField
                  name="password"
                  type="password"
                  prefix={
                    <img
                      src={passwordIMG}
                      alt="password"
                      style={{ marginTop: 6 }}
                    />
                  }
                  placeholder={t("forgotPassword.password")}
                  label={
                    <Text color="subdued" variant="bodySm">
                      Create password
                    </Text>
                  }
                  value={newPassword}
                  error={errorNewPassword}
                  onBlur={() => validatePassword(newPassword)}
                  onChange={(value) => {
                    setNewPassword(value);
                    setErrorNewPassword(false);
                  }}
                />
                <TextField
                  name="password_rereat"
                  type="password"
                  prefix={
                    <img
                      src={passwordIMG}
                      alt="password"
                      style={{ marginTop: 6 }}
                    />
                  }
                  placeholder="Repeat your password"
                  label={
                    <Text color="subdued" variant="bodySm">
                      {t("forgotPassword.repPass")}
                    </Text>
                  }
                  value={newPasswordRepeat}
                  error={errorNewPasswordRepeat}
                  onBlur={() => validatePasswordRepeat(newPasswordRepeat)}
                  onChange={(value) => {
                    setNewPasswordRepeat(value);
                    setErrorNewPasswordRepeat(false);
                  }}
                />
              </FormLayout>

              <br />
              <div>
                <Button
                  variant="primary"
                  onClick={doForgotComplete}
                  loading={isCompleting}
                  disabled={isCompleting || isPasswordChanged}
                >
                  Recover
                </Button>
                <button style={{ display: "none" }} type="submit">
                  {t("forgotPassword.signIn")}
                </button>
              </div>
            </form>
          )}
        </>
      }
    />
  );
}
